<template>
  <div>
    <div v-if="list.length !== 0" class="barcode-scanner__products-list" :style="styles">
      <div class="barcode-scanner__products-list_item d-flex"
           v-for="item in list"
           :key="item.id"
      >
        <div class="row" style="width: 100%">
          <div class="col-lg-8 my-2 col-10 d-flex">
            <div class="item-content d-flex">
              <div class="name">{{item.name}}</div>
              <div class="ean">EAN: {{item.ean}}</div>
            </div>
          </div>
          <div class="col-lg-2 my-2 p-0 col-10 d-flex">
            <button class="spin-btn" @click="editProduct(item, 'remove')">-</button>
            <div class="ean mx-3">{{item.count}}</div>
            <button class="spin-btn" @click="editProduct(item, 'add')">+</button>
          </div>
          <div class="col-lg-2 my-2 p-0 col-2">
            <b-input-group>
              <template #append>
                <b-button
                  size="sm"
                  @click="removeProduct(item.id)"
                  variant="danger"
                >
                  <b-icon icon="trash-fill" />
                </b-button>
              </template>
            </b-input-group>
          </div>
        </div>
      </div>
    </div>
    <div  v-if="showReturnBackButton && list.length === 0" :style="grid" style="justify-content: center; display:flex">
      <buttonComponent
        class="btn btn-next"
        @click.native="goToSelectProducts()"
        :textColor="white"
        text="Produkte hinzufügen"
        backgroundColor="var(--brand-color-2)"
        borderColor="var(--brand-color-2)"
        :borderRadius='"50rem"'
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import buttonComponent from "@/components/renderers/button-component.vue";

export default {
  name: 'productsList',
  components: {
    buttonComponent
  },
  props: {
    styles: {
      type: Object,
      required: false
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    showReturnBackButton: {
      type: Boolean,
      default: false
    },
    maxProductCount: Number
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      list: state => state.scannedProducts
    })
  },
  methods: {
    ...mapActions(["removeProduct", "editQuantityProduct", "editInputQuantityProduct"]),
    editProduct (product, action) {
      let data = { product, action, maxProductCount: this.maxProductCount };
      this.editQuantityProduct(data);
      if (!product.count) {
        this.removeProduct(product.id);
      }
    },
    goToSelectProducts () {
      this.goToPage({
        pageName: 'productSelection',
        shouldBack: true
      }, this)
    }
  }
}
</script>

<style scoped lang="scss">
.spin-btn {
  width: 25px;
  height: 25px;
  color: #fff;
  background: linear-gradient(45deg, var(--button-gradient-4) 0%, var(--button-gradient-3) 100%) !important;
  border: none;
  border-radius: 4px;
  &:hover {
    background: linear-gradient(45deg, var(--button-gradient-4) 0%, var(--button-gradient-3) 100%) !important;
  }
}
.barcode-scanner__products-list {
  width: 100%;
  padding: 20px;
  background: #FFFFFF;
  border: 1px solid #6BB1FF;
  box-sizing: border-box;
  border-radius: 16px;

  @media (max-width: 767px) {
    padding: 0;
  }
  &_item {
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    div {
      align-items: center;
    }
    .item-content {
      flex-direction: column;
      padding-left: 10px;
      align-items: flex-start;

      letter-spacing: 0px;
      color: #000000;


      .name {
        font: normal normal 600 14px/18px 'Plus Jakarta Sans';
      }

      .ean {
        font: normal normal 500 14px/18px 'Plus Jakarta Sans';
      }
    }
  }
  .circle {
    display: flex;
    width: 44px;
    height: 44px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    background-color: #9ADFE6;
    border-radius: 2em;
  }
}

.select-none {
  user-select: none;
}

.short-logo {
  width: 36px;
}

.btn-info {
  width: 44px;
  height: 44px;
  border-radius: 100% !important;
  font-size: 0;
  line-height: 1;
  background-color: var(--color9);
  border: 0;
  &:focus {
    outline: 0 !important;
    box-shadow: none;
  }

  .input-group-prepend &{
    background-image: url("../../assets/icons/minus.svg");
    background-size: 50%;
    background-position: center;
    background-repeat: no-repeat;
  }
  .input-group-append &{
    background-image: url("../../assets/icons/plus.svg");
    background-size: 50%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.btn-danger {
  background: 0;
  border: 0;
  border-radius: 0;
  color: #6F6F6F;
  &:focus {
    outline: 0 !important;
    box-shadow: none;
  }
}
.btn-edit {
  background: 0;
  border: 0;
  &:focus {
    outline: 0 !important;
    box-shadow: none;
  }
  img {
    width: 70%;
  }
}

.input-group {
  justify-content: flex-end;
  .form-control {
    border: 0;
    padding: 0;
    margin: 0 5px;
    text-align: center;
    flex: 0 1 26%;
    &:focus {
      outline: 0 !important;
      box-shadow: none;
    }
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
}
</style>
